package com.eladfinish.bible.contest.screens.main.data

import com.eladfinish.bible.contest.SharedRes.images
import com.eladfinish.bible.contest.SharedRes.strings
import com.eladfinish.bible.contest.about
import com.eladfinish.bible.contest.action_reorder
import com.eladfinish.bible.contest.bible_recordings
import com.eladfinish.bible.contest.browse
import com.eladfinish.bible.contest.complete_chapter
import com.eladfinish.bible.contest.complete_verse
import com.eladfinish.bible.contest.exit
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.ic_screen_about
import com.eladfinish.bible.contest.ic_screen_browse
import com.eladfinish.bible.contest.ic_screen_complete_chapter
import com.eladfinish.bible.contest.ic_screen_complete_verse
import com.eladfinish.bible.contest.ic_screen_exit
import com.eladfinish.bible.contest.ic_screen_help
import com.eladfinish.bible.contest.ic_screen_mikud
import com.eladfinish.bible.contest.ic_screen_misc
import com.eladfinish.bible.contest.ic_screen_multiple_choice_questions
import com.eladfinish.bible.contest.ic_screen_names
import com.eladfinish.bible.contest.ic_screen_pair_matching
import com.eladfinish.bible.contest.ic_screen_recordings
import com.eladfinish.bible.contest.ic_screen_reorder
import com.eladfinish.bible.contest.ic_screen_search
import com.eladfinish.bible.contest.ic_screen_title_activity_settings
import com.eladfinish.bible.contest.lexicographically
import com.eladfinish.bible.contest.mikud
import com.eladfinish.bible.contest.multiple_choice_questions
import com.eladfinish.bible.contest.open_questions
import com.eladfinish.bible.contest.pair_matching
import com.eladfinish.bible.contest.past_quizzes
import com.eladfinish.bible.contest.pyramid_crossword
import com.eladfinish.bible.contest.screen_misc
import com.eladfinish.bible.contest.screen_names_in_bible
import com.eladfinish.bible.contest.screens.main.data.ButtonType.ABOUT
import com.eladfinish.bible.contest.screens.main.data.ButtonType.BROWSE
import com.eladfinish.bible.contest.screens.main.data.ButtonType.COMPLETE_CHAPTER
import com.eladfinish.bible.contest.screens.main.data.ButtonType.COMPLETE_VERSE
import com.eladfinish.bible.contest.screens.main.data.ButtonType.EXIT
import com.eladfinish.bible.contest.screens.main.data.ButtonType.HELP
import com.eladfinish.bible.contest.screens.main.data.ButtonType.LEXICOGRAPHICAL_SORT
import com.eladfinish.bible.contest.screens.main.data.ButtonType.MIKUD
import com.eladfinish.bible.contest.screens.main.data.ButtonType.MISC
import com.eladfinish.bible.contest.screens.main.data.ButtonType.MULTIPLE_CHOICE_QUESTIONS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.NAMES
import com.eladfinish.bible.contest.screens.main.data.ButtonType.OPEN_QUESTIONS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.PAIR_MATCHING
import com.eladfinish.bible.contest.screens.main.data.ButtonType.PAST_QUIZZES
import com.eladfinish.bible.contest.screens.main.data.ButtonType.PYRAMID_CROSSWORD
import com.eladfinish.bible.contest.screens.main.data.ButtonType.RANDOM_VERSE
import com.eladfinish.bible.contest.screens.main.data.ButtonType.RECORDINGS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.REORDER
import com.eladfinish.bible.contest.screens.main.data.ButtonType.SEARCH
import com.eladfinish.bible.contest.screens.main.data.ButtonType.SETTINGS
import com.eladfinish.bible.contest.screens.main.data.ButtonType.TELEGRAM_CHANNEL
import com.eladfinish.bible.contest.screens.main.data.ButtonType.UNKNOWN
import com.eladfinish.bible.contest.screens.main.data.ButtonType.VERSE_WIDGET
import com.eladfinish.bible.contest.search_in_bible
import com.eladfinish.bible.contest.telegram_channel
import com.eladfinish.bible.contest.title_activity_settings
import com.eladfinish.bible.contest.title_random_verse
import com.eladfinish.bible.contest.verse_widget
import dev.icerock.moko.resources.StringResource

fun ButtonType.toButtonData(): Pair<ButtonType, ButtonData> =
    this to when (this) {
        NAMES -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_names),
            stringResource = strings.screen_names_in_bible,
        )

        RANDOM_VERSE -> ButtonData(
            icon = ButtonIcon.Vector(RandomVerseIcon),
            stringResource = strings.title_random_verse,
        )

        VERSE_WIDGET -> ButtonData(
            icon = ButtonIcon.Vector(VerseWidgetIcon),
            stringResource = strings.verse_widget,
        )

        COMPLETE_VERSE -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_complete_verse),
            stringResource = strings.complete_verse,
        )

        SEARCH -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_search),
            stringResource = strings.search_in_bible,
        )

        COMPLETE_CHAPTER -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_complete_chapter),
            stringResource = strings.complete_chapter,
        )

        PAIR_MATCHING -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_pair_matching),
            stringResource = strings.pair_matching,
        )

        MULTIPLE_CHOICE_QUESTIONS -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_multiple_choice_questions),
            stringResource = strings.multiple_choice_questions,
        )

        PYRAMID_CROSSWORD -> ButtonData(
            icon = ButtonIcon.Vector(PyramidCrosswordIcon),
            stringResource = strings.pyramid_crossword,
        )

        OPEN_QUESTIONS -> ButtonData(
            icon = ButtonIcon.Vector(OpenQuestionsIcon),
            stringResource = strings.open_questions,
        )

        BROWSE -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_browse),
            stringResource = strings.browse,
        )

        MIKUD -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_mikud),
            stringResource = strings.mikud,
        )

        RECORDINGS -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_recordings),
            stringResource = strings.bible_recordings,
        )

        TELEGRAM_CHANNEL -> ButtonData(
            icon = ButtonIcon.Vector(TelegramIcon),
            stringResource = strings.telegram_channel,
        )

        PAST_QUIZZES -> ButtonData(
            icon = ButtonIcon.Vector(PastQuizzesIcon),
            stringResource = strings.past_quizzes,
        )

        LEXICOGRAPHICAL_SORT -> ButtonData(
            icon = ButtonIcon.Vector(LexicographicalSortHebrewIcon),
            stringResource = strings.lexicographically,
        )

        SETTINGS -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_title_activity_settings),
            stringResource = strings.title_activity_settings,
        )

        MISC -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_misc),
            stringResource = strings.screen_misc,
        )

        ABOUT -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_about),
            stringResource = strings.about,
        )

        HELP -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_help),
            stringResource = strings.help,
        )

        REORDER -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_reorder),
            stringResource = strings.action_reorder,
        )

        EXIT -> ButtonData(
            icon = ButtonIcon.Resource(images.ic_screen_exit),
            stringResource = strings.exit,
        )

        UNKNOWN -> throw IllegalArgumentException("Unknown button type")
    }

fun ButtonType.toStringResource(): StringResource =
    toButtonData().second.stringResource
